module.exports = __webpack_public_path__ + "img/KwanzaaFresh-Logo_White.e5dd97cd.svg";